import { SERVIZI, STRATI, COLORE_STATO, contaStati } from './data/servizi';
import { INCIDENTI, GRAVITA_COL } from './data/incidenti';
import type { Vista } from './ConsoleLayout';

const AZIONI: Record<string, { primaria?: string; secondaria?: string }> = {
  protocollo: { primaria: 'Configura' },
  feasr: { primaria: 'Riprova', secondaria: 'Vedi log' },
  skill: { secondaria: 'Sospendi' },
  revisione: { secondaria: 'Assegna revisori' },
  tetto: { secondaria: 'Rivedi il tetto' },
  reindex: { secondaria: 'Vedi job' },
  gpu: { secondaria: 'Vedi nodi' },
};

const MOSTRATI = 4;   // la coda mostra le più urgenti, e lo DICHIARA

export function StatoPiattaforma({ onVista }: { onVista: (v: Vista) => void }) {
  const conta = contaStati(SERVIZI);
  const coda = [...INCIDENTI].sort(
    (a, b) => (a.gravita === b.gravita ? 0 : a.gravita === 'bloccante' ? -1 : 1),
  );
  const inStrati = SERVIZI.filter((s) => s.strato !== 'trasversali').length;
  const trasv = SERVIZI.length - inStrati;

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', flexWrap: 'wrap', gap: 14 }}>
        <div>
          <h1>Stato della piattaforma</h1>
          {/* I numeri sono DERIVATI: non scriverli a mano, si disallineano. */}
          <p className="lede">
            {SERVIZI.length} servizi: {inStrati} sui quattro strati, {trasv} trasversali.
          </p>
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
          <span className="uc-pill regolare">{conta.regolare} regolari</span>
          <span className="uc-pill sorveglianza">{conta.sorveglianza} da sorvegliare</span>
          <span className="uc-pill bloccante">{conta.bloccante} bloccanti</span>
        </div>
      </div>

      <section className="uc-coda" id="attenzione">
        <header>
          <h2>Richiede la tua attenzione</h2>
          <span style={{ fontSize: 12.5, color: 'var(--uc-ink-3)' }}>
            Le {Math.min(MOSTRATI, coda.length)} più urgenti delle {coda.length} aperte, in ordine di impatto.
          </span>
        </header>
        {coda.slice(0, MOSTRATI).map((i) => {
          const az = AZIONI[i.id] || {};
          return (
            <div className="uc-coda-riga" key={i.id}>
              <span className="uc-punto" style={{ background: GRAVITA_COL[i.gravita] }} aria-hidden="true" />
              <div className="testo">
                <div className="titolo">{i.titolo}</div>
                {/* La conseguenza, non solo il sintomo: dice PERCHÉ importa. */}
                <div className="conseguenza">{i.sintomo}</div>
              </div>
              <span className="mono" style={{ fontSize: 11.5, color: '#6b7180' }}>{i.strato}</span>
              <div className="uc-coda-azioni">
                {az.secondaria && <button type="button" className="uc-btn secondario">{az.secondaria}</button>}
                {az.primaria && <button type="button" className="uc-btn primario">{az.primaria}</button>}
                <button type="button" className="uc-btn secondario" onClick={() => onVista('aiuto')}>
                  Chiedi aiuto
                </button>
              </div>
            </div>
          );
        })}
      </section>

      <div style={{ marginTop: 20 }}>
        {STRATI.map((st) => {
          const righe = SERVIZI.filter((s) => s.strato === st.id);
          const ia = st.id === 'conoscenza' || st.id === 'intelligenza';
          return (
            <section className={ia ? 'uc-strato ia' : 'uc-strato'} key={st.id} id={st.id}>
              <header>
                <span className="num">{st.numero}</span>
                <h2>{st.titolo}</h2>
                <span className="sotto">{st.sottotitolo}</span>
              </header>
              <div className="uc-scroll">
                <table className="uc-tab">
                  <tbody>
                    {righe.map((s) => (
                      <tr key={s.id}>
                        <td><span className="uc-punto" style={{ background: COLORE_STATO[s.stato] }} aria-hidden="true" /></td>
                        <td className="nome">{s.nome}</td>
                        <td style={{ color: s.stato === 'regolare' ? 'var(--uc-ink-3)' : s.stato === 'bloccante' ? 'var(--uc-rosso-testo)' : 'var(--uc-ambra-testo)' }}>
                          {s.attivita}
                        </td>
                        <td className="meta">{s.metrica}</td>
                        <td className="quando">{s.quando}</td>
                        <td><a href={'/console/' + s.id}>{s.azione}</a></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </section>
          );
        })}
      </div>
    </>
  );
}
